import {getLastCaller,inspect} from './../imports.js';
export function debugPrint(
  value: unknown,
  label: string | null = null
) {
  const caller = getLastCaller();

  const header =
    label ??
    (caller
      ? `${caller.functionName} @ ${caller.file}:${caller.line}`
      : "object");

  console.log(`\n🔍 ${header}`);
  console.log(
    inspect(value, {
      depth: null,
      colors: true,
      compact: false,
      maxArrayLength: null,
    })
  );
}
